import { render, staticRenderFns } from "./ListActiveDetailVa.vue?vue&type=template&id=5e473e5c&scoped=true&"
import script from "./ListActiveDetailVa.vue?vue&type=script&lang=js&"
export * from "./ListActiveDetailVa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e473e5c",
  null
  
)

export default component.exports